const defaultTextColor = "#22303e";
const positiveColor = "#088752";
const secondaryTextColor = "#65797b";
const headerTextColor = "#007486";
const labelColor = "#56616c";
const sectionBackgroundColor = "#e8eaee";
const linkColor = "#1768c9";
const cardBackgroundColor = "#ebf5fd";
const secondaryCardBackgroundColor = "#F1F4F7";
const completedColor = "#1768c9";
const incompleteColor = "#ccc";
const cardBannerColor = "#ecf4fc";
const surgePayBannerColor = "#56616c";
const surgePayBannerTextColor = "#FFFFFF";
const statusCompleteCheckColor = "green70";
const statusErrorColor = "red70";
const statusPendingColor = "neutral70";
const bonusBackgroundColor = "primary05";
const bonusTextColor = "primary80";
const popoverTextColor = "primary70";
const majorSectionBackgroundColor = "neutral0";
const newUIBackgroundColor = "#E2E2E2";

export {
  defaultTextColor,
  positiveColor,
  secondaryTextColor,
  headerTextColor,
  labelColor,
  sectionBackgroundColor,
  linkColor,
  cardBackgroundColor,
  secondaryCardBackgroundColor,
  completedColor,
  incompleteColor,
  cardBannerColor,
  surgePayBannerColor,
  surgePayBannerTextColor,
  statusCompleteCheckColor,
  statusErrorColor,
  statusPendingColor,
  bonusBackgroundColor,
  bonusTextColor,
  popoverTextColor,
  majorSectionBackgroundColor,
  newUIBackgroundColor,
};
